<template>
  <div class="d-block px-2 py-3">
    <ModalDelete ref="ModalDelete" confirm-text="ya" @action="removeData">
      <template v-slot:title>
        <span class="primary--text text-capitalize font-weight-bold">Batalkan Transaksi</span>
      </template>
      <template v-slot:body>
        <div class="text-center">
          Apakah Anda yakin ingin menghapus "
          <span class="text-capitalize" v-if="selectedItem">{{ selectedItem.slider_name }}</span>"?
        </div>
      </template>
    </ModalDelete>
    <!-- assdd
    {{ sliderData }} -->
    <v-expansion-panels v-model="panel" id="filter-produkcard" tile accordion focusable class="accordion-filter">
      <v-expansion-panel>
        <v-expansion-panel-header class="text-uppercase font-weight-bold text-body-2 px-3 py-3 mt-5">
          <div><v-icon>mdi-filter-outline</v-icon>Filter</div>
        </v-expansion-panel-header>

        <v-expansion-panel-content class="px-4 pt-4 pb-0 mt-2 border" outlined>
          <v-form>
            <v-row>
              <v-col cols="6" class="py-0">
                <v-text-field v-model="sliderNameFilter.value" outlined small dense hide-details class="searchInput"
                  placeholder="cari judul">
                  <div slot="append">
                    <v-btn small elevation="2" color="success">
                      <v-icon center>mdi-magnify</v-icon>
                    </v-btn>
                  </div>
                </v-text-field>
              </v-col>
            </v-row>

            <v-row>
              <v-col cols="12" class="text-right pb-0 pt-5 mt-3">
                <v-btn color="success" elevation="2" dark class="mr-3" width="140" @click="cari">
                  <strong class="text-uppercase">Cari</strong>
                </v-btn>

                <v-btn color="error" elevation="2" outlined dark width="140" @click="resetFilter">
                  <strong class="text-uppercase">Reset</strong>
                </v-btn>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-content>
      </v-expansion-panel>
    </v-expansion-panels>

    <v-row class="mt-4 align-center">
      <v-col cols="12" sm="6">
        <div class="text-subtitle-2 font-weight-bold">
          {{ slider_by_type.title }}
          <v-chip small class="ma-2" :color="slider_by_type.colorCount" outlined>{{
      sliderPagination.total_data
    }}</v-chip>
        </div>
      </v-col>
      <v-col cols="12" sm="6" :class="isMobile ? 'text-left pt-0' : 'text-right'">
        <v-btn color="black" elevation="2" dark @click="addSlider()">
          <v-icon color="white darken-1 mr-2">mdi-plus</v-icon>
          <strong class="text-capitalize">
            <small>Tambah</small>
          </strong>
        </v-btn>
      </v-col>
    </v-row>

    <v-row class="mb-4">
      <v-col cols="12" sm="6">
        <v-autocomplete @input="cari" v-model="sort" :items="listSort" item-text="sortLabel" return-object outlined
          dense hide-details placeholder="Urutkan dari" class="rounded-lg text-body-2"
          no-data-text="Belum ada data tersedia"></v-autocomplete>
      </v-col>
    </v-row>

    <v-layout v-resize="onResize" column>
      <v-data-table :server-items-length="sliderPagination.total_data" hide-default-footer v-model="selected"
        :loading="loading" :headers="headers" :items="sliderData" :expanded.sync="expanded" single-expand
        item-key="slider_id" show-expand class="elevation-1 border" :class="{ mobile: isMobile }" id="product-table">
        <template v-slot:header.slider_name="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>

        <template v-slot:header.slider_is_active="{ header }">
          <span class="black--text font-weight-bold text-capitalize">{{ header.text }}</span>
        </template>
        <template v-slot:item.slider_name="{ item }">
          <div class="d-flex" :class="isMobile ? 'flex-column align-start justify-start' : 'flex-row align-center'">
            <v-img :width="isMobile ? 120 : 80" :max-width="isMobile ? 80 : 50" class="mr-3 my-3"
              :src="item.slider_image[0] ? item.slider_image[0] : '/assets/product/default.png'"></v-img>

          </div>
          {{ item.slider_name }}
        </template>


        <template v-slot:item.slider_is_active="{ item }">
          <v-switch v-model="item.slider_is_active" true-value="active" false-value="inactive"
            :class="isMobile ? 'pb-3 mb-3' : 'pa-3'" dense
            @change="ubahStatus($event, item.slider_id, item)"></v-switch>
        </template>

        <template v-slot:expanded-item="{ headers, item }">
          <td :colspan="headers.length">
            <v-row>
              <v-col cols="12" class="text-right">
                <router-link :to="{
      name: 'seller-slider-ubah',
      params: { id: item.slider_id, slug: item.slider_slug_name }
    }">
                  <v-btn small color="grey darken-2" elevation="1" outlined tile dark
                    :class="isMobile ? 'v-btn--block white mb-2 py-4' : 'white mr-2'">
                    <span class="text-capitalize font-weight-medium black--text">
                      <v-icon medium
                        class="grey--text darken-1 font-weight-normal mr-2">mdi-pencil-box-outline</v-icon>Edit
                    </span>
                  </v-btn>
                </router-link>

                <v-btn small color="error" elevation="1" outlined tile dark
                  :class="isMobile ? 'v-btn--block white py-4' : 'white'" @click="hapus(item)">
                  <span class="text-capitalize font-weight-medium">
                    <v-icon medium class="error--text darken-1 font-weight-normal mr-2">mdi-delete-outline</v-icon>Hapus
                    Slider
                  </span>
                </v-btn>
              </v-col>
            </v-row>
          </td>
        </template>

        <template v-slot:no-data>
          <div class="d-flex flex-column align-center py-5 px-5">
            <v-img width="300" :aspect-ratio="16 / 16" class="py-5 my-4  "
              src="/assets/seller/belum-ada-barang.svg"></v-img>
            <div class="text-h6 black--text">Slider yang Anda cari tidak ditemukan</div>
            <!-- <p>Barang jualan kamu akan muncul di halaman ini. Ayo mulai berjualan di <strong class="green--text">Pasaroa</strong> sekarang!</p> -->
          </div>
        </template>
      </v-data-table>
    </v-layout>

    <v-pagination v-if="sliderPagination.total_page > 1 && sliderData.length > 0" @input="updatePage" v-model="page"
      :length="sliderPagination.total_page" total-visible="7" circle
      class="d-flex justify-end no-button-focus py-2"></v-pagination>

  </div>
</template>

<script>
import { mapState, mapActions } from "vuex";
import ModalDelete from "@/components/ModalDelete";

export default {
  components: {
    ModalDelete
  },

  data() {
    return {
      loading: false,
      page: 1,
      limit: 8,
      params: [],
      sort: {},
      sortBy: "",
      sortDir: "",

      panel: [0],
      sliderNameFilter: {
        value: "",
        comparison: "like",
        type: "string",
        field: "slider_name"
      },

      filter: {
        search: "",
        categoryId: null,
        minStock: 0,
        maxStock: 0,
        minSold: 0,
        maxSold: 0
      },
      selected: [],
      expanded: [],
      headers: [
        {
          text: "Info Slider",
          align: "start",
          sortable: false,
          value: "slider_name",
          width: "40%"
        },
        {
          text: "Link",
          align: "start",
          sortable: false,
          value: "slider_link",
        },
        { text: "Status", value: "slider_is_active", sortable: false },
        { text: "", value: "data-table-expand" }
      ],
      selectedItem: null,
      dialogReminderStock: false,
      isMobile: false,

      listSort: [
        {
          sortBy: "slider_name",
          sortDir: "ASC",
          sortLabel: "[A-Z]"
        },
        {
          sortBy: "slider_name",
          sortDir: "DESC",
          sortLabel: "[Z-A]"
        },
      ]
    };
  },

  props: {
    type: String
  },

  computed: {
    ...mapState("sliderSeller", ["sliderData", "sliderPagination"]),
    // ...mapState("category", ["category"]),

    slider_by_type() {
      let dataType = {
        title: "Semua",
        colorCount: "green"
      };
      switch (this.type) {
        case "all":
          dataType = {
            title: "Semua",
            colorCount: "green"
          };
          break;

        case "active":
          dataType = {
            title: "Aktif",
            colorCount: "green"
          };
          break;

        case "inactive":
          dataType = {
            title: "Draft",
            colorCount: "error"
          };
          break;

        default:
          return {
            title: "Semua",
            colorCount: "green"
          };
      }

      return dataType;
    }
  },

  methods: {
    ...mapActions("sliderSeller", ["getSlider", "statusSlider", "removeSlider"]),

    async ubahStatus(val, id, item) {
      await this.statusSlider({
        id: id,
        status: val
      })
        .then(() => {
          this.getDataSlider();
        })
        .catch(() => {
          if (item.slider_is_active == "active") {
            item.slider_is_active = "inactive";
          } else {
            item.slider_is_active = "active";
          }
        });
    },
    async getDataSlider() {
      this.loading = await true;
      switch (this.type) {
        case "all":
          break;
        case "active":
          this.params.push({
            value: "active",
            comparison: "=",
            type: "string",
            field: "slider_is_active"
          });
          break;
        case "inactive":
          this.params.push({
            value: "inactive",
            comparison: "=",
            type: "string",
            field: "slider_is_active"
          });
          break;

      }
      await this.getSlider(
        this.queryString({
          limit: this.limit,
          page: this.page,
          params: this.params,
          sort: this.sortBy,
          dir: this.sortDir
        })
      );
      this.loading = false;
    },
    cari() {
      this.params = [];

      if (this.sliderNameFilter.value) this.params.push(this.sliderNameFilter);

      this.sortBy = this.sort.sortBy;
      this.sortDir = this.sort.sortDir;
      this.page = 1;
      this.getDataSlider();
    },
    resetFilter() {
      this.sliderNameFilter.value = "";
      this.cari();
    },
    async hapus(item) {
      this.selectedItem = await item;
      this.$refs.ModalDelete.modalShow();
    },
    removeData() {
      this.removeSlider({ id: this.selectedItem.slider_id }).then(() => {
        this.page = 1;
        this.getDataSlider();
      });
    },
    async openReminderDialog(item) {
      this.selectedItem = await item;
      this.dialogReminderStock = true;
    },

    addSlider() {
      this.$router.push({ path: "/seller/slider/tambah" });
    },
    updatePage(val) {
      this.page = val;
      this.getDataSlider();
    },

    onResize() {
      if (window.innerWidth < 769) this.isMobile = true;
      else this.isMobile = false;
    }
  },
  async created() {
    this.loading = await true;
    await this.$store.dispatch("setPageTitle", "Slider");
    this.getDataSlider();
  }
};
</script>
